
export function isInIframe(): boolean {
    return window.parent !== window;
}
